import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="container-custom section-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Club Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <span className="font-heading font-black text-black text-lg">GDR</span>
              </div>
              <span className="font-heading font-bold text-xl tracking-tight">GDR ESPORÕES</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Fundado em 1979, o Grupo Desportivo e Recreativo de Esporões é um símbolo de orgulho e paixão pela comunidade de Esporões, Braga.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/gdresporoes"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/gdresporoes"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">NAVEGAÇÃO</h4>
            <ul className="space-y-3">
              {[
                { path: '/clube', label: 'O Clube' },
                { path: '/futebol', label: 'Futebol' },
                { path: '/jogos', label: 'Jogos' },
                { path: '/noticias', label: 'Notícias' },
                { path: '/galeria', label: 'Galeria' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">CONTACTOS</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-gray-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  Rua José Loureiro Duarte, 2<br />
                  Esporões - Braga
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-gray-400 flex-shrink-0" />
                <a href="tel:913789152" className="text-gray-400 hover:text-white transition-colors text-sm">
                  913 789 152
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-gray-400 flex-shrink-0" />
                <a href="mailto:geral@gdresporoes.pt" className="text-gray-400 hover:text-white transition-colors text-sm">
                  geral@gdresporoes.pt
                </a>
              </li>
            </ul>
          </div>

          {/* Admin Access */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">ADMINISTRAÇÃO</h4>
            <p className="text-gray-400 text-sm mb-4">
              Área reservada para gestão do website.
            </p>
            <Link
              to="/admin/login"
              className="inline-block border border-white/20 px-6 py-3 text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-all"
              data-testid="admin-login-link"
            >
              Área Admin
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} GDR Esporões. Todos os direitos reservados.
          </p>
          <p className="text-gray-500 text-xs">
            Desde 1979 • Esporões, Braga
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
